import request from '@/utils/request'
const BASE_URL = '/Goods'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  /** 获取商品库存 */
  getGoodsInventory(GoodsId, WarhouseId) {
    return request({
      url: BASE_URL + '/GetGoodsInventory',
      method: 'get',
      params: { GoodsId, WarhouseId }
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  getGoodsPrice(data) {
    return request({
      url: BASE_URL + '/GetGoodsPrice',
      method: 'post',
      data
    })
  },
  getGoodsOffer(data) {
    return request({
      url: BASE_URL + '/GetGoodsOffer',
      method: 'post',
      data
    })
  },
  getPictures(id) {
    return request({
      url: BASE_URL + '/GetPictures',
      method: 'get',
      params: { id }
    })
  },
  getGoodsInventory(GoodsId, WarhouseId) {
    return request({
      url: BASE_URL + '/GetGoodsInventory',
      method: 'get',
      params: { GoodsId, WarhouseId }
    })
  },
  uploadThumbnail: BASE_URL + '/UploadThumbnail', // 上传缩略图
  uploadPicture: BASE_URL + '/UploadPicture',
  deletePicture(picId) {
    
    return request({
      url: BASE_URL + '/DeletePicture',
      method: 'get',
      params: { picId }
    })
  },
  uploadMP4: BASE_URL + '/UploadMP4',
  export(data) {
    return request({
      url: BASE_URL + '/Export',
      method: 'post',
      responseType: 'blob',
      data
    }).then(res => {
      var file = res.data;
      var disposition = res.headers['content-disposition'];
      // 

      var fileName = "导出";
      if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
        var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
        fileName = decodeURI(text);
      }

      if (navigator.msSaveBlob) {
        // IE10+下载
        navigator.msSaveBlob(file, fileName);
      } else {
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.target = "_blank";
        elink.href = URL.createObjectURL(file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }
      return Promise.resolve();
    });
  },
  import: "/api" + BASE_URL + "/Import",
  importClass: "/api" + BASE_URL + "/ClassImport",
}